/* eslint-disable no-case-declarations */
import {
  SET_SAGEMAKER_URL, SENDING_SAGEMAKER_URL_REQUEST, SAGEMAKER_URL_REQUEST_FAILED, SET_SAGEMAKER_URL_EXIST,
} from '../../types/Types';

/** @type { Object } default state */
const defaultState = {
  sageMakerURLData: '',
  isSMSending: false,
  smUrlError: false,
  isSMURLSuccess: false,
  isSageMakerUrlExist: false,
};

/**
 * dispatched the user data to the store
 * @param  { Object } state  default state
 * @param  { Object } action dispacthed action from middleware
 */
export default function sageMakerUrl(state = defaultState, action = {}) {
  switch (action.type) {
    case SET_SAGEMAKER_URL:
      const data = {};
      data.sageMakerURLData = action.sageMakerURLData;
      data.isSMSending = action.isSMSending;
      data.isSMURLSuccess = action.isSMURLSuccess;
      data.isSageMakerUrlExist = action.isSageMakerUrlExist;
      data.smUrlError = action.smUrlError;
      return { ...state, ...data };

    case SET_SAGEMAKER_URL_EXIST:
      const urlCheck = {};
      urlCheck.sageMakerURLData = action.sageMakerURLData;
      urlCheck.isSMSending = action.isSMSending;
      urlCheck.isSMURLSuccess = action.isSMURLSuccess;
      urlCheck.isSageMakerUrlExist = action.isSageMakerUrlExist;
      urlCheck.smUrlError = action.smUrlError;
      return { ...state, ...urlCheck };

    case SENDING_SAGEMAKER_URL_REQUEST:
      const sendingRequest = {};
      sendingRequest.sageMakerURLData = action.sageMakerURLData;
      sendingRequest.isSMSending = action.isSMSending;
      sendingRequest.isSMURLSuccess = action.isSMURLSuccess;
      sendingRequest.isSageMakerUrlExist = action.isSageMakerUrlExist;
      sendingRequest.smUrlError = action.smUrlError;
      return { ...state, ...sendingRequest };

    case SAGEMAKER_URL_REQUEST_FAILED:
      const errors = {};
      errors.sageMakerURLData = action.sageMakerURLData;
      errors.isSMSending = action.isSMSending;
      errors.isSMURLSuccess = action.isSMURLSuccess;
      errors.isSageMakerUrlExist = action.isSageMakerUrlExist;
      errors.smUrlError = action.smUrlError;
      errors.fMsg = action.fMsg;
      return { ...state, ...errors };
    default: return state;
  }
}
